const baseUrl = process.env.NEXT_PUBLIC_STRAPI_API_URL;

export const buildImageSrc = (url?: string | null, fallback: string = '') => {
  if (!url) return fallback;
  const candidate = url;
  const isAbsolute = candidate.startsWith('http');
  return !isAbsolute && baseUrl ? `${baseUrl}${candidate}` : candidate;
};

export const formatLinkUrl = (url?: string | null) => {
  if (!url) return '/';
  const formattedUrl = url.replace(/_/g, '-');
  const normalized = formattedUrl.startsWith('/')
    ? formattedUrl.slice(1)
    : formattedUrl;

  if (normalized.startsWith('legal/')) {
    return `/${normalized}`;
  }

  const legalSlugs = new Set([
    'privacy-policy',
    'terms-and-conditions',
    'cookie-policy'
  ]);

  const resourceSlugs = new Set([
    'articles',
    'case-studies',
    'interviews',
    'spotlight',
    'tools-calculators'
  ]);

  const productSlugs = new Set([
    'product-origination',
    'product-borrower-portal',
    'product-servicing',
    'product-investor-portal',
    'product-investor-and-fund-management',
    'product-draw-management'
  ]);

  const solutionSlugs = new Set([
    'solution-national-lenders',
    'solution-regional-lenders',
    'solution-local-lenders'
  ]);

  if (productSlugs.has(normalized)) {
    return `/product/${normalized}`;
  }

  if (resourceSlugs.has(normalized)) {
    return `/resources/${normalized}`;
  }

  if (solutionSlugs.has(normalized)) {
    return `/solution/${normalized}`;
  }

  if (legalSlugs.has(normalized)) {
    return `/legal/${normalized}`;
  }

  return formattedUrl.startsWith('/') ? formattedUrl : `/${formattedUrl}`;
};
